import { combineReducers } from 'redux';
import addressesReducer from 'reducers/addressesReducer';
import editAddressReducer from 'reducers/editAddressReducer';
import addMedicationReducer from 'reducers/addMedicationReducer';
import authReducer from 'reducers/authReducer';
import errorReduce from 'reducers/errorReducer';
import medicationReducer from 'reducers/medicationReducer';
import orderHistoryReducer from 'reducers/orderHistoryReducer';
import patientReducer from 'reducers/patientReducer';
import paymentJourneyReducer from 'reducers/paymentJourneyReducer';
import nominationJourneyReducer from 'reducers/nominationJourneyReducer';
import addressFormReducer from 'reducers/addressFormReducer';
import pharmacyListReducer from 'reducers/pharmacyListReducer';
import messagesReducer from 'reducers/messagesReducer';
import configReducer from './configReducer';
import manualJourneyReducer from './manualJourneyReducer';

export default combineReducers({
  addresses: addressesReducer,
  editAddress: editAddressReducer,
  addMedication: addMedicationReducer,
  auth: authReducer,
  error: errorReduce,
  medication: medicationReducer,
  messages: messagesReducer,
  orderHistory: orderHistoryReducer,
  patient: patientReducer,
  paymentJourney: paymentJourneyReducer,
  nominationJourney: nominationJourneyReducer,
  addressForm: addressFormReducer,
  pharmacyList: pharmacyListReducer,
  config: configReducer,
  manualJourney: manualJourneyReducer,
});
